import React from "react";
import styles from "./HeadingPaper.css";

const HeadingPaper = ({ children }) =>
  children ? <div className={styles.heading}>{children}</div> : null;

export default HeadingPaper;



// WEBPACK FOOTER //
// ./src/components/HeadingPaper/HeadingPaper.js